module.exports = __webpack_public_path__ + "/login_ui/img/mk-a76072d1ad3b0298761af92c782e0713.svg";